import { createLazyComponentSilent } from 'utils/lazyLoad';

export default createLazyComponentSilent(() => import('./one-project-plan-page'));
